import { Feature } from "ol";
import Geometry from "ol/geom/Geometry";
import { LatLonDMS } from "./coord-dms";
import { ImportCSVTableFieldModel } from "./ImportCSV";

export class RouteSegmentsCsvModel {
  table : ImportCSVTableFieldModel[] = [];
  dataStartingLine : number = 2;
  fieldSeparator : string = ";";
  decimalSeparator : string = "Dot";
  layerName : string;
  lineWeight : number = 2;
  lineColor : string = '#0000FF';
  lineColorNullVal : string = '#FF0000';
  file : File;
  fileContent : RouteSegmentsCSVContent[] = [];
  features: Feature<Geometry>[] = [];

  fillTable() : void {
    this.table.push(new ImportCSVTableFieldModel("Sequence Number","J"));
    this.table.push(new ImportCSVTableFieldModel("Designation","B"));
    this.table.push(new ImportCSVTableFieldModel("Start Segment Point Latitude","S"));
    this.table.push(new ImportCSVTableFieldModel("Start Segment Point Longitude","T"));
    this.table.push(new ImportCSVTableFieldModel("End Segment Point Latitude","V"));
    this.table.push(new ImportCSVTableFieldModel("End Segment Point Longitude","W"));
    this.table.push(new ImportCSVTableFieldModel("Lower Vertical Distance","AE"));
    this.table.push(new ImportCSVTableFieldModel("Upper Vertical Distance","AF"));
    this.table.push(new ImportCSVTableFieldModel("Lower Vertical Units of Measurement","AD"));
    this.table.push(new ImportCSVTableFieldModel("Upper Vertical Units of Measurement","AC"));
    this.table.push(new ImportCSVTableFieldModel("Start Point Name","R"));
    this.table.push(new ImportCSVTableFieldModel("End Point Name","U"));
  }

  saveData(): RouteSegmentsCsvModel{
    let newModel : RouteSegmentsCsvModel = new RouteSegmentsCsvModel();
    newModel.dataStartingLine = this.dataStartingLine;
    newModel.fieldSeparator = this.fieldSeparator;
    newModel.decimalSeparator = this.decimalSeparator;
    newModel.layerName = this.layerName;
    newModel.lineWeight = this.lineWeight;
    newModel.lineColor = this.lineColor;
    newModel.lineColorNullVal = this.lineColorNullVal;
    newModel.features = this.features;
    return newModel;
  }
}


export class RouteSegmentsCSVContent{

  sequenceNumber : number;
  designation : string;
  startSegmentPointLatitude : string;
  startSegmentPointLongitude : string;
  endSegmentPointLatitude : string;
  endSegmentPointLongitude : string;
  lowerVerticalDistance : string;
  upperVerticalDistance : string;
  lowerVerticalUnitsMeasurement : string;
  upperVerticalUnitsMeasurement : string;
  startPointName : string;
  endPointName : string;

  static map(csvLine: any, table: ImportCSVTableFieldModel[]): RouteSegmentsCSVContent {

    var line : RouteSegmentsCSVContent = new RouteSegmentsCSVContent();
    line.sequenceNumber = Number(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Sequence Number",table))]);
    line.designation = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Designation",table))];
    line.startSegmentPointLatitude = this.getCoordinatePoint(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Start Segment Point Latitude",table))]);
    line.startSegmentPointLongitude = this.getCoordinatePoint(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Start Segment Point Longitude",table))]);
    line.endSegmentPointLatitude = this.getCoordinatePoint(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("End Segment Point Latitude",table))]);
    line.endSegmentPointLongitude = this.getCoordinatePoint(csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("End Segment Point Longitude",table))]);
    line.lowerVerticalDistance = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Lower Vertical Distance",table))];
    line.upperVerticalDistance = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Upper Vertical Distance",table))];
    line.lowerVerticalUnitsMeasurement = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Lower Vertical Units of Measurement",table))];
    line.upperVerticalUnitsMeasurement = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Upper Vertical Units of Measurement",table))];
    line.startPointName = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("Start Point Name",table))];
    line.endPointName = csvLine[ImportCSVTableFieldModel.convertLetterToNumber(ImportCSVTableFieldModel.getLetterFromTable("End Point Name",table))];

    return line;
  }

  static getCoordinatePoint(value : string) : string {
    try{
      var signal : string = value[value.length-1];
      var obtainedCoord : LatLonDMS = new LatLonDMS();
      var transformedCoord = "";
      if(signal == "N" || signal == "S"){ //LAT
        obtainedCoord.latitude.cardinal = signal;
        obtainedCoord.latitude.degrees = parseInt(value.substring(0,2));
        obtainedCoord.latitude.minutes = parseInt(value.substring(2,4));
        obtainedCoord.latitude.seconds = parseInt(value.substring(4,6));
        transformedCoord = obtainedCoord.toLat().toString();
      }
      if(signal == "W" || signal == "E"){//LON
        obtainedCoord.longitude.cardinal = signal;
        obtainedCoord.longitude.degrees = parseInt(value.substring(0,3));
        obtainedCoord.longitude.minutes = parseInt(value.substring(3,5));
        obtainedCoord.longitude.seconds = parseInt(value.substring(5,7));
        transformedCoord = obtainedCoord.toLon().toString();
      }

      return transformedCoord;
    }
    catch(e){
      return null;
    }
  }
}
